import type { ReaderTag } from '@/api/client';
import { ReaderCatalogTagPill } from '@/components/ReadersTable/ReaderCatalogTagPill';
import { CatalogTagsMoreBadge } from './CatalogTagsMoreBadge';

/** Off-screen measurer: натуральные ширины pill и бейджей «и ещё N…». */
export function CatalogTagsInlineMeasurer({
  measurerRef,
  tags,
}: {
  measurerRef: React.RefObject<HTMLDivElement | null>;
  tags: ReaderTag[];
}) {
  if (tags.length === 0) return null;
  const hiddenCounts = tags.map((_, i) => tags.length - i).filter((h) => h > 0);
  const uniqueHidden = [...new Set(hiddenCounts)];

  return (
    <div ref={measurerRef as React.Ref<HTMLDivElement>} className="catalog-tags-inline-badges-row__measurer" aria-hidden>
      <div className="catalog-tags-inline-badges-row__measurer-pills">
        {tags.map((t) => (
          <span key={t.id} data-catalog-tag-pill-measure>
            <ReaderCatalogTagPill tag={t} />
          </span>
        ))}
      </div>
      <div className="catalog-tags-inline-badges-row__measurer-more">
        {uniqueHidden.map((h) => (
          <span key={h} data-catalog-tag-more-measure={h}>
            <CatalogTagsMoreBadge hiddenCount={h} />
          </span>
        ))}
      </div>
    </div>
  );
}
